import { GridFilterItem } from '@mui/x-data-grid-pro';

import { FilterParam } from 'common/src/query-params/FilterParam';
import { ArrayOperators } from 'common/src/query-params/operators';

type FilterItemWithExtras = GridFilterItem & {
  additionalFilters?: FilterParam[];
  replaceBaseFilter?: boolean;
};

export const getApiActiveFilters = (
  activeFilters: FilterItemWithExtras[],
): FilterParam[] => {
  return activeFilters.flatMap((filterItem) => {
    const baseFilter: FilterParam = {
      field: filterItem.field,
      operator: filterItem.operator as FilterParam['operator'],
      value: filterItem.value,
    };
    const { additionalFilters = [], replaceBaseFilter = false } = filterItem;

    return replaceBaseFilter
      ? additionalFilters
      : [baseFilter, ...additionalFilters];
  });
};

export const normalizeFilterItems = (
  items: GridFilterItem[],
): GridFilterItem[] => {
  return items;
};

export const getNonEmptyFilterItems = (
  items: GridFilterItem[],
): GridFilterItem[] => {
  return items.filter(({ value }) => {
    if (Array.isArray(value)) {
      return value.every((valueItem) => !!valueItem);
    }

    if (typeof value === 'string') {
      return value.trim().length > 0;
    }

    return value !== null && value !== undefined;
  });
};
